import React, { useState } from "react";
import * as moment from "moment";
import { FORMAT } from "utils/dateOfBirthValidation";
import { Field, FieldArray } from "formik";
import NumberInput from "components/FormElements/NumberInput";
import DatePicker from "components/FormElements/DatePicker";
import TimePickerInput from "components/FormElements/TimePickerInput"
import TextInput from "components/FormElements/TextInput";
import AlertModal from "components/AlertModal";
import DisabledInput from "components/FormElements/DisabledInput";
import PlusRoundIcon from "assets/svg/PlusRoundIcon"

const LoadDetails = ({ props, isModifyForm, maxQuantityState, editResponse, callBack, loadsCallBack,locale}) => {
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  let loadArr = []

  if (editResponse?.data?.loadDetails) {
    loadArr.push(editResponse?.data?.loadDetails)
  }


  const addMoreLoads = (item, index, arrayHelpers) => {
    return <div className="loan-detail-wrapper">
      {/* <Field name={`addMoreArrList.${index}`} /> */}
      <div className="responsive-mb-32">
        <NumberInput
          className="responsive"
          name={`addMoreArrList.[${index}].lots`}
          // name={"lots"+ index}
          placeholder={locale('numberOfLoads')}
          maxLength="4"
          maxQuantity={10}
          decimalScale={0}
          showErrorMessages={true}
          disabled={isModifyForm}
          onChangeHandler={(value) => {
          }}
        />
      </div>
      <div className="responsive-mb-32">
        <NumberInput
          className="responsive"
          // name={"QuantityLot" + index}
          name={`addMoreArrList.[${index}].QuantityLot`}
          placeholder={locale('quantityPerLoad')}
          maxLength={4}
          maxQuantity={maxQuantityState || 540}
          showErrorMessages={true}
          decimalScale={0}
          onChangeHandler={(value) => {
            // if (!value) setQuantityError("Quantity Lot is required.")
            // else setQuantityError("")

            // callBack(value)
            //setQuantityValueState(value);
          }}
        />
      </div>

      <div className="responsive-mb-32 ">
        <DatePicker
          className="responsive"
          // name={"requestDeliveryDate" + index}
          name={`addMoreArrList.[${index}].requestDeliveryDate`}
          placeholderText=""
          // editResponse={editResponse}
          selectedDate={item?.requestDeliveryDate}
          disabled={props.values.recurringCheckBoxFlag}
          selectedValue={props.values.addMoreArrList[index].requestDeliveryDate}
          callBackFun={() => {

          }}
        />
      </div>

      <div className="responsive-mb-32" style={{ display: "flex", gap: '15px' }}>
        <div>
          <span className="other-label">{locale('from')}</span>
          <TimePickerInput
            className="responsive"
            //  name={"appt" + index}
            name={`addMoreArrList.[${index}].appt`}
            editResponse={editResponse}
            showErrorMessages={true}
            fromValue={props.values.appt}
            toValue={props.values.apptTo}
            disabled={props.values.recurringCheckBoxFlag}
            selectedTimeValue={props.values.addMoreArrList[index].appt}
            onChangeHandler={(time) => {
              if (time === "00:00") {
              }
            }}
          />
        </div>
        <div>
          <span className="other-label">{locale('to')}</span>
          <TimePickerInput
            className="responsive"

            //  name={"appt" + index}
            name={`addMoreArrList.[${index}].apptTo`}
            editResponse={editResponse}
            endTime="23:00"
            fromValue={props.values.appt}
            toValue={props.values.apptTo}
            showErrorMessages={true}
            disabled={props.values.recurringCheckBoxFlag}
            selectedTimeValue={props.values.addMoreArrList[index].apptTo}
            onChangeHandler={(time) => {

              if (time === "00:00") {
                // setModalContent("Please enter correct time.");
                // setModalLink("");
                // toggleModal();
              }
            }}
          />
        </div>
      </div>

      <div className="responsive-mb-32">
        <TextInput
          className="responsive"
          // name={'poNumber' + index}
          name={`addMoreArrList.[${index}].poNumber`}
          placeholder="PO#"
          inputType={"poNumber"}
          maxLength='20'
          showErrorMessages={true}
        />
      </div>
      {!isModifyForm &&
        <>
          {props.values.addMoreArrList.length > 1 && props.values.addMoreArrList.length - 1 !== index && <><button
            type="button"
            className="responsive-mb-32"
            onClick={() => {
              arrayHelpers.remove(index)
            }} // remove a friend from the list
          >
            {locale('remove')}
          </button>
          </>}

          {props.values.addMoreArrList.length - 1 === index && <button
            type="button"
            className="add-more mb-32"
            style={{ background: props.values.recurringCheckBoxFlag && '#a9a9a9' }}
            disabled={props.values.recurringCheckBoxFlag}
            onClick={() => {
              //   if (!props.values.addMoreArrList[index].lots) {
              //       setModalContent("Load is required.");
              //       setModalLink("");
              //       toggleModal();
              //       return false
              //   }
              //   if (!props.values.addMoreArrList[index].QuantityLot) {
              //       setModalContent("Quantity per load is required.");
              //       setModalLink("");
              //       toggleModal();
              //       return false
              //   }
              //   if (props.values.addMoreArrList[index].appt === "00:00") {
              //       setModalContent("Please enter correct time.");
              //       setModalLink("");
              //       toggleModal();
              //       return false
              //   }
              //   if (props.values.addMoreArrList[index].apptTo === "00:00") {
              //     setModalContent("Please enter correct time.");
              //     setModalLink("");
              //     toggleModal();
              //     return false
              // }
              let obj = {
                lots: "",
                QuantityLot: props.values.addMoreArrList[index].QuantityLot || props.values.QuantityLot,
                requestDeliveryDate: props.values.requestDeliveryDate,
                appt: props.values.appt,
                apptTo: props.values.apptTo,
                poNumber: ""
              }
              arrayHelpers.push(obj)
              // arrayHelpers.push(index, "")
            }} // insert an empty string at a position
          >
            <PlusRoundIcon />{locale('addMore')}
          </button>}
        </>
      }
    </div>
  }
  const fieldArray = () => {
    return <FieldArray
      name="addMoreArrList"
      render={arrayHelpers => (
        <div>
          {props.values.addMoreArrList && props.values.addMoreArrList.length > 0 && (
            props.values.addMoreArrList.map((item, index) => (
              <div key={index}>
                {addMoreLoads(item, index, arrayHelpers)}
              </div>
            ))
          )
          }
        </div>
      )}
    />
  }
  return (
    <>
      <div className="loan-detail-wrapper">
        <div className="label-heading responsive-mt-24">
          <p>{locale('loadDetails')}<span className="star">*</span></p>
        </div>
        <div></div>
        <div className="label-heading responsive-mt-24">
          <p>{locale('deliveryDate')}<span className="star">*</span></p>
        </div>
        <div className="label-heading responsive-mt-24">
          <p>{locale('appointmentWindow')}<span className="star">*</span></p>
        </div>
      </div>

      {fieldArray()}

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title="Alert"
        content={modalContent}
        link={modalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
      />
    </>
  )
};

export default LoadDetails;